import React from "react";

const Footer = () => {
    return(
        <div className="footer-container">
            <div className="content">
                <h4>RONNIE TECH</h4>
                <p>
                    All rights reserved to follow the copy 
                    right of the website and so this website 
                    is meant for study purpose and all the 
                    content is for study purpose free of charge
                    to bypass all kinds of google account from 
                    Android 4  Android 11.
                </p>
            </div>
            <div className="footer-links">
                <ul>
                    <li>
                        <a href="/">Home</a>
                        <a href="/about">About</a>
                        <a href="/contact">Contact</a>
                    </li>
                </ul>
            </div>
            <div className="copyright">
                <h4>Copyright 2024</h4>
            </div>
        </div>
    )
}

export default Footer;
